import { useBinderMediaUrl } from "./binder-api.js";

/**
 * Renders one binder photo by fetching a short-lived presigned GET URL for its
 * mediaId. Used in the entry detail gallery and the editor's existing-photos
 * list. Optionally shows a remove button.
 */
export function BinderMediaThumb({
  propertyId,
  entryId,
  mediaId,
  onRemove,
}: {
  propertyId: string;
  entryId: string;
  mediaId: string;
  onRemove?: () => void;
}) {
  const { data, isLoading } = useBinderMediaUrl(propertyId, entryId, mediaId);
  return (
    <div className="relative">
      {data?.url ? (
        <img src={data.url} alt="" className="aspect-square w-full rounded-md object-cover" />
      ) : (
        <div
          className={`aspect-square w-full rounded-md bg-slate-100 ${isLoading ? "animate-pulse" : ""}`}
        />
      )}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label="Remove photo"
          className="absolute right-1 top-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-black/60 text-xs text-white"
        >
          ×
        </button>
      )}
    </div>
  );
}
